/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-else-return */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  steproot: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 30,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  counter: {
    backgroundColor: (props) => {
      if (props.completed && !props.active) {
        return 'rgba(38, 187, 237, 0.6)';
      }
      if (props.active) {
        return '#26BBED';
      } else {
        return 'rgba(153,153,153,0.5)';
      }
    },
    width: 24,
    height: 24,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    fontFamily: 'Open Sans',
    borderRadius: 12,
  },
  steplabel: {
    marginLeft: 8,
    fontWeight: (props) => (props.active ? 600 : 400),
    fontSize: 16,
    lineHeight: '24px',
    color: '#333',
    '&:hover': {
      color: (props) => (props.active ? '#333' : '#26BBED'),
    },
  },
}));
const Step = ({ count, label, active, completed, disabled, onStepCLickedCallback }) => {
  const classes = useStyles({ active, completed });

  return (
    <div
      className={classes.steproot}
      onClick={() => disabled ? null : onStepCLickedCallback(count - 1)}
    >
      <div className={classes.counter}>{count}</div>
      <Typography className={classes.steplabel} variant="body1">
        {label}
      </Typography>
    </div>
  );
};

export default Step;
